import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const ExtensionPointProvider = withAsync({
    loader: lazyForPaint(
        () => import(/* webpackChunkName: "forge-extension-point-provider" */ './extension-point-provider')
    ),
    LoadingSkeleton: () => null,
});
